/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_stopwatch_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is a lap on a stopwatch?`)
};

const es_timer_stopwatch_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es una vuelta en un cronómetro?`)
};

const de_timer_stopwatch_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist eine Runde bei einer Stoppuhr?`)
};

const nl_timer_stopwatch_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is een ronde bij een stopwatch?`)
};

const fr_timer_stopwatch_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu’est-ce qu’un tour sur un chronomètre ?`)
};

const it_timer_stopwatch_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è un giro su un cronometro?`)
};

const pt_br2_timer_stopwatch_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é uma volta no cronômetro?`)
};

const pt_timer_stopwatch_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é uma volta num cronómetro?`)
};

const ja_timer_stopwatch_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストップウォッチのラップとは何ですか？`)
};

const zh_timer_stopwatch_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`秒表上的“圈”是什么意思？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_stopwatch_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_stopwatch_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_stopwatch_faq1_q", locale)
	if (locale === "en") return en_timer_stopwatch_faq1_q(inputs)
	if (locale === "es") return es_timer_stopwatch_faq1_q(inputs)
	if (locale === "de") return de_timer_stopwatch_faq1_q(inputs)
	if (locale === "nl") return nl_timer_stopwatch_faq1_q(inputs)
	if (locale === "fr") return fr_timer_stopwatch_faq1_q(inputs)
	if (locale === "it") return it_timer_stopwatch_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_stopwatch_faq1_q(inputs)
	if (locale === "pt") return pt_timer_stopwatch_faq1_q(inputs)
	if (locale === "ja") return ja_timer_stopwatch_faq1_q(inputs)
	return zh_timer_stopwatch_faq1_q(inputs)
};